import { render, staticRenderFns } from "./homePlatform.vue?vue&type=template&id=4cb79547&scoped=true&"
import script from "./homePlatform.vue?vue&type=script&lang=js&"
export * from "./homePlatform.vue?vue&type=script&lang=js&"
import style0 from "./homePlatform.vue?vue&type=style&index=0&id=4cb79547&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb79547",
  null
  
)

export default component.exports